module.exports = __webpack_public_path__ + "media/new/red-32-ebc4c932.png";